import { ApolloClient } from '@apollo/client';
import { find } from 'lodash';
import { CustomerType, INextArticle, IOrder, IVehicleConfiguration } from 'next-common';
import React, { useEffect, useState } from 'react';
import { IGetServiceContract } from 'sales-types-common';
import { ICentralisedProperties, IVehiclePageProps, useDisableScroll } from '../../../../../common';
import { isSigningPage } from '@utils/sales/offer';
import { getActiveStep, getStepData, IStepMenuData } from '../../../sales-wizard/sales-wizard-menu';
import { ModalState } from '../HeaderEnum';
import { PageSteps } from '../NewHeaderWrapper';
import { TradeInModal } from './TradeInModal';
import { CartPrices, cn } from 'types';
import { Button, IconType, SmartLink } from '@repo/ui/components';
import { formatNumber } from 'types';

const DefaultSign = () => <>-</>;

interface ITradeInProps {
  order?: IOrder;
  activeStep?: number;
  showNoData?: boolean;
  allStepData?: IStepMenuData[];
  setTradeInClicked: (value: boolean) => void;
  orderId?: string;
  rootUrl?: string;
  isVarebilEnabled?: boolean;
  onClick(stepData?: IStepMenuData): void;
}

export interface INewHeaderSection extends IVehiclePageProps, ICentralisedProperties {
  children?: React.ReactNode;
  showNoData: boolean;
  displayPrices: boolean;
  vehicle?: IVehicleConfiguration;
  showCustomerPopup?: boolean;
  serialNo?: string;
  class?: string;
  serviceContract?: IGetServiceContract;
  articles?: INextArticle[];
  vatPrices?: CartPrices;
  client?: ApolloClient<object>;
  rootUrl?: string;
  order?: IOrder;
  setTradeInClicked: (value: boolean) => void;
  onCustomerType(customerType: CustomerType): void;
  setShowCustomerPopup?(value: boolean): void;
}

const TradeInInfoBox = (props: INewHeaderSection) => {
  const activeStep = getActiveStep(props.rootUrl, props?.isVarebilEnabled);
  const stepData = getStepData(activeStep, props.orderId, props.rootUrl, props?.isVarebilEnabled);
  const tradeInVehicles = props?.order?.tradeInVehicles;
  const customer = props?.order?.customer;
  const totalCapital =
    tradeInVehicles?.map((tradeInVehicle) => tradeInVehicle?.capital)?.reduce((total, current) => total + current, 0) ||
    0;
  const isBusiness = customer?.bosCustomer?.customerType === CustomerType[CustomerType.BUSINESS];
  const [modal, setModal] = useState(ModalState.NONE);
  useDisableScroll(modal === ModalState.TRADEIN);

  return (
    <>
      <div>
        {tradeInVehicles?.length > 0 || isSigningPage(props.allStepData) ? (
          //tradeInLabel
          <label className="text-white text-sm/[170%]">
            {tradeInVehicles?.length > 1 ? `Innbytte (${tradeInVehicles.length} biler) ` : 'Innbyttebil '}
            {`${isBusiness ? '(ekskl.' : '(inkl.'} mva)`}
          </label>
        ) : null}

        {isSigningPage(props.allStepData) ? (
          <div className="">
            <label className="text-lg/[175%] font-bold text-white text-md">
              {tradeInVehicles?.length > 0 ? `${formatNumber(totalCapital)} kr` : '0 kr'}
            </label>
          </div>
        ) : props.showNoData ? (
          <DefaultSign />
        ) : tradeInVehicles === null || tradeInVehicles?.length <= 0 ? (
          <Button
            appearance="outline"
            onClick={() => {
              props?.setTradeInClicked(true);
              props?.onClick(find(stepData, { routeIsActive: true }));
            }}
            className="border border-white group"
          >
            <span className="text-white group-hover:text-black">Legg til innbyttebil</span>
          </Button>
        ) : (
          <SmartLink
            className={tradeInVehicles?.length > 0 && ''}
            onLinkClick={() => {
              props?.setTradeInClicked(true);
              props?.onClick(find(stepData, { routeIsActive: true }));
            }}
            customClasses={'text-[var(--color-white)] border-[var(--color-white)]'}
            iconColor={'var(--color-white)'}
            iconRight={tradeInVehicles?.length > 0 && IconType.NewNextEdit}
            iconSize={24}
          >
            <span className="text-base/[175%] font-extrabold">
              {tradeInVehicles?.length > 0 ? `${formatNumber(totalCapital)} kr` : 'Legg til'}
            </span>
          </SmartLink>
        )}
      </div>
      {modal === ModalState.TRADEIN && <TradeInModal order={props.order} modal={modal} setModal={setModal} />}
    </>
  );
};

export const SalesAndInfoSection = (props: INewHeaderSection) => {
  const [updatedOrder, setUpdatedOrder] = useState<IOrder>(null);

  useEffect(() => {
    setUpdatedOrder(props.order);
  }, [props.order]);
  useEffect(() => {
    if (!updatedOrder?.tradeInVehicles) {
      //initialize trade if with empty array if trade is not present
      setUpdatedOrder((updatedOrder) => ({
        ...updatedOrder,
        tradeInVehicles: [],
      }));
    }
  }, [updatedOrder]);
  return (
    <div
      className={cn(
        // use 'right-[18rem]' when trade in button is available
        'absolute right-12 cursor-pointer',
        !!isSigningPage(props.allStepData) ? 'cursor-default' : ''
      )}
    >
      {updatedOrder?.tradeInVehicles && !updatedOrder?.isAgent && props?.activeStep !== PageSteps.START && (
        <TradeInInfoBox {...props} />
      )}
    </div>
  );
};
